import * as React from "react";
import { Table, Col, Row, Grid } from "react-bootstrap";
import { EstructuraCentroTrabajo, EstructuraEmpresa, EstructuraSuraEmpresa } from "../modelo/EstructuraEmpresa";
import ContenidoPestañaEmpresa from "./ContenidoPestañaEmpresa";
import icoBuilding from "../../../../../../assets/img/ico-building.png";

export default class TablaCentrosTrabajoEmpresa extends React.Component<TablaCentrosTrabajoEmpresaProps, TablaCentrosTrabajoEmpresaState> {
    
    constructor(props: any) {
        super(props);

        this.state = {
            listaCT: [],
            totalCT: 0,
            listaPaginada: [],
            paginaActual: 0,
            registrosPorPagina: 20 
        };
    }

    componentDidMount() {
        if(this.state.listaCT.length === 0 || this.state.listaPaginada.length === 0) {
            this.obtenerListaCT();
        }
    }
    
    render() {
        return(
            <div>
                <ContenidoPestañaEmpresa
                    estructuraEmpresa={this.props.estructuraEmpresa}
                    estructuraSuraEmpresa={this.props.estructuraSuraEmpresa}
                    tituloCabecera={"Datos Centros de Trabajo Sistema de Afiliación Transaccional"}
                    contenido={this.renderContenido()}
                />
            </div>
        );
    }

    renderContenido() {
        const {listaPaginada} = this.state;

        return(
            <Table striped responsive bordered condensed hover>
                <tbody>
                    {
                        listaPaginada.map((centroTrabajo, index) => (
                        <tr key={index}>
                            <td>
                                <Grid style={{width: '1050px'}}>
                                    <Row className="show-grid" style={{marginTop: '15px', marginBottom: '10px'}}>
                                        <Col sm={1}>
                                            <img src={icoBuilding} style={{position: 'absolute', top: 5, left: 20, height: 65, width: 65}}/>
                                        </Col>
                                        <Col sm={4} md={4}>
                                            <div style={{fontSize: '14px'}}>
                                                <Row><b className="title-col">{centroTrabajo.informacionCT.nombreCentroTrabajo}</b></Row>
                                                <Row><b className="title-col">{centroTrabajo.informacionCT.codigoCentroTrabajo}</b></Row>
                                                <Row>{centroTrabajo.informacionCT.direccionCT}</Row>
                                            </div>
                                        </Col>
                                        <Col sm={4} md={3}>
                                            <div style={{fontSize: '14px'}}>
                                                <Row><b>Municipio:</b> {centroTrabajo.informacionCT.municipio}</Row>
                                                <Row>
                                                    <b>Zona Ubicación:</b> 
                                                    {` ${(centroTrabajo.informacionCT.zonaUbicacion === 'R' ? 'RURAL' : 
                                                         (centroTrabajo.informacionCT.zonaUbicacion === 'U' ? 'URBANA' : 
                                                         centroTrabajo.informacionCT.zonaUbicacion))}`}
                                                </Row>
                                                <Row><b>Sede:</b> {centroTrabajo.nombreSede}</Row>
                                                <Row><b>Código Sede:</b> {centroTrabajo.codigoSede}</Row>
                                                <Row><b>Actividad Económica:</b> {centroTrabajo.informacionCT.codigoActividadEconomica}</Row>
                                            </div>
                                        </Col>
                                        <Col sm={4} md={4}>
                                            <div style={{fontSize: '14px'}}>
                                                <Row><b>Doc. Responsable:</b> {centroTrabajo.documentoCompletoResponsable}</Row>
                                                <Row><b>Nombre Responsable:</b> {centroTrabajo.nombreCompletoResponsable}</Row>
                                                <Row><b>Correo Eléctronico:</b> {centroTrabajo.informacionCT.correoElectronico}</Row>
                                                <Row><b>Teléfono:</b> {centroTrabajo.informacionCT.telefono}</Row>
                                                <Row><b>Total Empleados:</b> {centroTrabajo.informacionCT.empleados.length}</Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </Grid>
                            </td>
                        </tr>
                        ))
                    }
                </tbody>
            </Table>
        );
    }

    obtenerListaCT() {
        const totalSedes = this.props.estructuraEmpresa.sedes.length;
        const listaCT: Array<DatosCT> = [];
        if(totalSedes > 0) {
            this.props.estructuraEmpresa.sedes.forEach(sede => {
                if(sede.centrosTrabajo.length > 0) {
                    sede.centrosTrabajo.forEach(ct => {
                        listaCT.push({
                            informacionCT: ct,
                            codigoSede: sede.codigoSede,
                            nombreSede: sede.nombreSede,
                            documentoCompletoResponsable: this.construirDocumentoResponsableCT(ct),
                            nombreCompletoResponsable: this.construirNombreResponsableCT(ct)
                        });
                    });
                }
            });
        }

        let numRegistros;
        
        if (listaCT.length < this.state.registrosPorPagina) {
            numRegistros = listaCT.length;
        } else {
            numRegistros = this.state.registrosPorPagina;
        }

        const listaPaginada = this.calcularCTPorPagina(listaCT, numRegistros, 1);

        this.setState({
            listaCT: listaCT,
            paginaActual: 1,
            listaPaginada: listaPaginada,
            registrosPorPagina: numRegistros
        });
    }

    calcularCTPorPagina(listaTrabajadores: Array<DatosCT>, registrosPorPagina: number, paginaNum: number) {
        return listaTrabajadores.slice((paginaNum - 1) * registrosPorPagina, paginaNum * registrosPorPagina);
    }

    actualizarCTPaginacion(pageIndex: number, registrosPorPagina: number) {
        const listaPaginadaCT = this.calcularCTPorPagina(this.state.listaCT, registrosPorPagina, pageIndex + 1);
        this.setState({
            listaPaginada: listaPaginadaCT,
            registrosPorPagina: registrosPorPagina, 
            paginaActual: pageIndex
        });
    }

    construirDocumentoResponsableCT(estructuraCentroTrabajo: EstructuraCentroTrabajo) {
        return(
            `${estructuraCentroTrabajo.tipoDocumentoResponsableCT}${estructuraCentroTrabajo.numeroDocumentoResponsableCT}`
        );
    }

    construirNombreResponsableCT = (estructuraCentroTrabajo: EstructuraCentroTrabajo) => {
        return(
            `${estructuraCentroTrabajo.primerNombreResponsableCT} ${estructuraCentroTrabajo.segundoNombreResponsableCT}
             ${estructuraCentroTrabajo.primerApellidoResponsableCT} ${estructuraCentroTrabajo.segundoApellidoResponsableCT} `
        );
    };
}

interface TablaCentrosTrabajoEmpresaProps {
    estructuraEmpresa: EstructuraEmpresa,
    estructuraSuraEmpresa?: EstructuraSuraEmpresa
}

interface TablaCentrosTrabajoEmpresaState {
    listaCT: Array<DatosCT>,
    totalCT: number,
    listaPaginada: Array<DatosCT>,
    paginaActual: number,
    registrosPorPagina: number 
}

interface DatosCT {
    informacionCT: EstructuraCentroTrabajo,
    documentoCompletoResponsable: string,
    nombreCompletoResponsable: string,
    codigoSede: string,
    nombreSede: string
}


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/estructura_empresas/componentes/TablaCentrosTrabajoEmpresa.tsx